import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "coinbase"
    }}>{`Coinbase`}</h2>
    <p>{`Coinbase Global, Inc., branded Coinbase, is an American publicly traded company that operates a cryptocurrency exchange platform. Coinbase is a distributed company; all employees operate via remote work. It is the largest cryptocurrency exchange in the United States by trading volume.`}</p>
    <blockquote>
      <p parentName="blockquote">{`In Pixer Laravel we integrate Coinbase Commerce API. Coinbase Commerce does not provide test or sandbox environment, So be careful. It will cost you money even in testing.`}</p>
    </blockquote>
    <h3 {...{
      "id": "coinbase-integrate-inside-pixer"
    }}>{`Coinbase integrate inside Pixer.`}</h3>
    <p>{`Please follow & complete this steps for Coinbase integration for your e-commerce system.`}</p>
    <ul>
      <li parentName="ul">{`Inside `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file copy & paste this line of codes. We will discuss later about how to create those API keys in Coinbase.`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`# Payment -> CoinBase
COINBASE_API__KEY=
 
SHOP_URL=[YOUR_SHOP_URL]
`}</code></pre>
    <b>SHOP_URL=[YOUR_SHOP_URL]</b> This parameter is must have in .env file when Coinbase is using. Otherwise the payment redirection will be broken.
    <ul>
      <li parentName="ul">
        <p parentName="li">{`In Pixer `}<inlineCode parentName="p">{`Laravel Http`}</inlineCode>{` Client has been used to implement Coinbase Commerce.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Activate Coinbase from Pixer admin dashboard. (e.g. webhook URL is coming from local development. This static link will dynamically generated in live environment)`}</p>
      </li>
    </ul>
    <p><img alt="paypal-Pixer-dashboard" src={require("../images/payment-images/coinbase_payment_webhook.png")} /></p>
    <h2 {...{
      "id": "how-to-create--setup-coinbase-information-properly"
    }}>{`How to create & setup Coinbase information properly?`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Create an account in `}<a parentName="p" {...{
            "href": "https://beta.commerce.coinbase.com/signup"
          }}>{`https://beta.commerce.coinbase.com/signup`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Get API key from your dashboard. Copy the API_KEY then set it to `}<inlineCode parentName="p">{`COINBASE_API__KEY`}</inlineCode>{` env variable.
`}<img alt="coinbase_commerce_api_key" src={require("../images/payment-images/coinbase_commerce_api_key.png")} /></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`Coinbase Commerce`}</inlineCode>{` do not provide any kind of test or sandbox environment.`}</p>
      </li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Webhook is most import thing to manage payments status with coinbase setup.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`To Set Webhook notification URL go to coinbase commerce dashboard -> settings -> notification set url `}</li>
    </ul>
    <p><img alt="coinbase_commerce_webhooks" src={require("../images/payment-images/coinbase_commerce_webhooks.png")} /></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Available Webhooks Status.`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <b>charge:created</b> New charge is created
          </li>
          <li parentName="ul">
            <b>charge:confirmed</b> Charge has been confirmed and the associated payment is completed
          </li>
          <li parentName="ul">
            <b>charge:failed</b> Charge failed to complete
          </li>
          <li parentName="ul">
            <b>charge:delayed</b> Charge received a payment after it had been expired
          </li>
          <li parentName="ul">
            <b>charge:pending</b> Charge has been detected but has not been confirmed yet
          </li>
          <li parentName="ul">
            <b>charge:resolved</b> Charge has been resolved
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`At last, For going live with your application please follow this official API Guide `}<a parentName="p" {...{
            "href": "https://docs.cloud.coinbase.com/commerce/reference"
          }}>{`https://docs.cloud.coinbase.com/commerce/reference`}</a>{` and documentation `}<a parentName="p" {...{
            "href": "https://docs.cloud.coinbase.com/commerce/docs/welcome"
          }}>{`https://docs.cloud.coinbase.com/commerce/docs/welcome`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      